import type {TableConfiguration} from 'schema/table/types';
import {defaultTableConfig} from 'schema/table/configuration/defaultTableConfig';
import type {MetadataId} from '../../../types';
import {getFirstArrayStringValueOrStringValue} from '../../../scenes/advancedSearch/functions/getFirstArrayStringValueOrStringValue';
import {MetadataLink} from '../../../scenes/advancedSearch/schemas/renderers/table/MetadataLink';
import {Isbn} from '../../renderers';
import {DateMultiple} from '../../renderers/table';
import {advancedSearchDefaultColumns} from './columns';

export const advancedSearchTableConfig: TableConfiguration = {
  ...defaultTableConfig,
  defaultColumns: advancedSearchDefaultColumns,
  hideColumnSelector: true,
  disableFiltering: true,
  partValueDelimiter: {
    generalNote: '; ',
    workGeneralNote: '; ',
  },
  partValueRenderers: {
    ean: MetadataLink,
    workId: MetadataLink,
    isbn: Isbn,
    salesRestrictionStartDate: DateMultiple,
    licenseFromDate: DateMultiple,
    licenseUntilDate: DateMultiple,
  },
  partValueGetters: {
    ean: (part, value, row) => {
      const ean = getFirstArrayStringValueOrStringValue(row?.['ean']);

      if (!row || !ean) {
        return value;
      }

      const metadataId: MetadataId = {
        ean,
        workId: getFirstArrayStringValueOrStringValue(row?.['workId']),
      };

      return metadataId;
    },
    workId: (part, value, row) => {
      const workId = getFirstArrayStringValueOrStringValue(row?.['workId']);

      if (!row || !workId) {
        return value;
      }

      const metadataId: MetadataId = {
        workId,
        ean: getFirstArrayStringValueOrStringValue(row?.['ean']),
      };

      return metadataId;
    },
  },
  hideFooter: false,
  pinnedColumns: {
    left: ['ean'],
  },
  scrollAfterPagination: true,
};
